import * as React from "react";
import { SVGProps } from "react";
export const CaretDownIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.39601 11.875L7.35401 9.833C7.07668 9.55567 7.01068 9.23633 7.15601 8.875C7.30201 8.51367 7.57635 8.333 7.97901 8.333H12.083C12.4723 8.333 12.7397 8.51367 12.885 8.875C13.031 9.23633 12.9653 9.55567 12.688 9.833L10.646 11.875C10.5627 11.9583 10.4653 12.0243 10.354 12.073C10.2433 12.1217 10.1323 12.146 10.021 12.146C9.90968 12.146 9.79868 12.1217 9.68801 12.073C9.57668 12.0243 9.47935 11.9583 9.39601 11.875Z"
            fill="currentColor"
        />
    </svg>
);
CaretDownIcon.displayName = "CaretDownIcon";
